import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { PageRequest } from '@apaq/leap-data-core'
import { Account, AccountResource, Invitation, InvitationResource, SubscriptionPlan, SubscriptionPlanResource, VERSION, WorkScheduleResource } from '@apaq/orgkit-js';
import { container } from 'tsyringe';
import { InvitationDialogComponent, Result } from '../invitation-dialog/invitation-dialog.component';
import { DialogService } from 'src/app/modules/dialog/dialog.service';
import { SecurityEditorComponent } from '../resource-editor-view/security-editor/security-editor.component';
import { Roles } from 'src/app/common/security/roles';
import { ContextService } from 'ngx-orgkit';

@Component({
  selector: 'app-resource-list-view',
  templateUrl: './resource-list-view.component.html',
  styleUrls: ['./resource-list-view.component.scss']
})
export class ResourceListViewComponent {

  invitations?: Invitation[];
  accounts?: Account[];
  modalVisible = false;
  invitee?: string;
  currentAccount?: Account;
  subscriptionPlan?: SubscriptionPlan;
  initialized = false;


  constructor(private router: Router,
    private dialogService: DialogService,
    private context: ContextService,
    private workscheduleResource: WorkScheduleResource,
    private accountResource: AccountResource,
    private invitationResource: InvitationResource,
    private subscriptionPlanResource: SubscriptionPlanResource) { }

  ngOnInit(): void {
    this.load();

    this.loadDefaults();
  }

  async loadDefaults() {
    this.currentAccount = await this.accountResource!.findById('current');
    const plans = await this.subscriptionPlanResource?.findAll();

    plans?.content.forEach(plan => {
      if (plan.type === 'Core') {
        this.subscriptionPlan = plan;
      }
    });

  }

  viewUser(account: Account) {
    this.router.navigate(['people', account.id]);
  }

  showHelp() {
    window.open('https://docs.previsto.com/help/generelt/virksomhed/medarbejdere', '_blank');
  }

  showModal() {
    const data = {plan: this.subscriptionPlan, currency: this.currency};
    const ref = this.dialogService.open(InvitationDialogComponent, $localize`Invite team members`, {data});
    ref.afterClosed().subscribe(async (result: Result) => {
      if(result != null) {
        const inv = {
          email: result.email.trim(),
          role: result.role
        } as Invitation;
        await this.invitationResource?.save(inv);
        this.load();
      }
    });
  }

  editSecurity(event: MouseEvent, account: Account) {
    this.dialogService.open(SecurityEditorComponent, '', {headerStyle: 'hidden', data: account}).afterClosed().subscribe((result) => {
      if(result === 'changed') {
        this.load();
      }
    });
    event.stopPropagation();

  }

  public isAdmin(account: Account) {
    return this.hasRoles(account, ['ADMIN']);
  }

  public isManager(account: Account) {
    return this.hasRoles(account, ['MANAGEMENT']) && !this.hasRoles(account, ['ADMIN']);
  }

  public isTrustedEmployee(account: Account) {
    return this.hasRoles(account, ['USER']) && !this.hasRoles(account, ['ADMIN']) && !this.hasRoles(account, ['MANAGEMENT']);
  }

  public isEmployee(account: Account) {
    return this.hasRoles(account, ['EMPLOYEE']);
  }

  public hasRoles(account: Account, requiredRoles: string[]) {
    return Roles.hasRolesForOrganization(this.context.organizationId!, account, requiredRoles);
  }

  public getRoles(account: Account): string[] {
    const orgId = this.context.organizationId;
    const roles: string[] = [];
    account.roles.forEach(r => {
      const roledata = r.split('_');
      if (roledata[0] === 'ORGROLE' && roledata[1] === orgId) {
        roles.push(roledata[2]);
      }
    });

    return roles;
  }

  public async cancelInvitation(invitation: Invitation) {
    await this.invitationResource?.delete(invitation)
    this.load();
  }

  get currency() {
    return this.subscriptionPlan?.currencyCode.toUpperCase();
  }

  private async load() {
    this.accounts = (await this.accountResource!.findAll({ size: 500, sort: 'name' })).content;
    this.invitations = (await this.invitationResource!.findAll({ query: { accepted: 'false' }, size: 100 } as PageRequest)).content;
    this.initialized = true;
  }
}
